import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { RouteName, TextKey } from '@mews-commander/enums';
import { PaymentChargePreauthorization } from '@mews-commander/modules/src/modules/payment';
import { MewsTeam, RouteType } from '@mews/enums';

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Payment/ChargePreauthorization/$accountId')({
    validateSearch: z.object({
        /**
         * Whoever thought that it would be a good idea to mix casing on the same query param was wrong
         */
        SelectedPreauthorizationId: z.string().uuid().optional(),
        selectedPreauthorizationId: z.string().uuid().optional(),
        BillId: z.string().uuid().optional(),
        billId: z.string().uuid().optional(),
    }),
    component: Component,
    staticData: {
        title: TextKey.PreauthorizationCharge,
        routeName: RouteName.PaymentChargePreauthorization,
        owner: MewsTeam.PaymentExperience,
        type: RouteType.Frontend,
    },
});

function Component() {
    const { accountId } = Route.useParams();
    const { SelectedPreauthorizationId, selectedPreauthorizationId, BillId, billId } = Route.useSearch();

    return (
        <PaymentChargePreauthorization
            accountId={accountId}
            // @ts-expect-error The typing of the component is lying
            preauthorizationId={SelectedPreauthorizationId ?? selectedPreauthorizationId ?? null}
            // @ts-expect-error The typing of the component is lying
            billId={BillId ?? billId ?? null}
        />
    );
}
